<template>
    <div>
        <MainNavigation/>


        <centered-card headline="Messenger">
            <div class="container">

                <div v-if="conversations.length<1 && !isLoading">
                    <h4>You do not have any messages yet.</h4>
                    <p>If you would like to start a chat, just visit a blog and click on "Send Message" on the upper right.</p>
                </div>

                <router-link
                        v-for="conversation in conversations"
                        tag="div" class="conversation" :key="conversation._id"
                        :to="{name:'MessengerDetail', params:{conversationId: conversation._id}}"
                >

                    <div class="row">
                        <div class="col-2">
                            <blog-avatar :blog="conversation.recipient.blog" :w="100" :h="100"/>
                        </div>
                        <div class="col-8">
                            <div v-if="amISender(conversation)">
                                <h4>{{conversation.recipient.blog.title}}</h4>
                            </div>
                            <div v-else>
                                <h4>{{conversation.sender.name}}@{{conversation.recipient.blog.title}}</h4>
                            </div>
                        </div>
                        <div class="col-2 text-right">
                            <span
                                v-if="conversation.newMessages && conversation.newMessages>0"
                                class="badge badge-primary">
                                {{conversation.newMessages}}
                            </span>
                        </div>
                    </div>

                </router-link>

                <loading-indicator name="messenger.getConversations"/>
            </div>
        </centered-card>

    </div>
</template>

<script>

  import MainNavigation from "../layout/MainNavigation";
  import CenteredCard from "../layout/CenteredCard";
  import BlogAvatar from "../ui/BlogAvatar";
  import LoadingIndicator from "../ui/LoadingIndicator";

  export default {
    name: "MessengerPage",
    data(){
      return {
        conversations:[],
        isLoading: false
      }
    },
    mounted(){
      this.loadConversations();
    },
    sockets: {
      receiveMessage(message){
        this.loadConversations();
      }
    },
    methods: {
      loadConversations(){
        this.isLoading = true;
        this.$api.getConversations()
          .then((res)=>{
            this.isLoading = false;
            this.conversations = res.data.conversations;
          })
          .catch((err)=>{
            this.isLoading = false;
          })
      },
      amISender(conversation){
        let userId = this.$store.getters['user/id'];
        return (conversation.sender._id === userId)
      }
    },
    components: {
      LoadingIndicator,
      BlogAvatar,
      CenteredCard,
      MainNavigation
    }
  }
</script>

<style lang="sass" scoped>

    @import '../../assets/sass/vars.scss'

    .conversation
        border-bottom: 1px solid #EEE
        padding: 1em
        cursor: pointer

        &:hover
            background-color: #F3F3F3

        .badge
            background-color: $colorPrimary
            color: #FFF
            font-size: 1em
            border-radius: 50%
            padding: .2em .6em
            display: inline-block
            min-width: 2em
            text-align: center


</style>



// WEBPACK FOOTER //
// src/components/messenger/MessengerPage.vue